import React, { Children, ReactElement } from 'react';
import { SortableElement } from 'react-sortable-hoc';

interface ISortableElementProps {
    className?: string,
    children: ReactElement
}
export const SortableItem = SortableElement((props: ISortableElementProps) => <div className={props.className || ""} >{props.children}</div>);